import { AxiosRequestConfig } from 'axios';

// https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation
declare module 'axios' {
    interface AxiosRequestConfig {
        meta?: any;
    }
}

const onFulfilled = (config: AxiosRequestConfig) => {
    config.meta = config.meta || {};
    config.meta.requestStartedAt = new Date().getTime();
    // config.headers.Swimlane = 'selftest-230816-152324-057';

    return config;
};

export default {
    onFulfilled,
};
